module.exports = __webpack_public_path__ + "static/media/natalia.ede5c2d9.png";